import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import DefaultAsideContent from './DefaultAsideContent/DefaultAsideContent';
import IncentivesAsideContent from './IncentivesAsideContent/IncentivesAsideContent';
import TeslaAsideContent from './TeslaAsideContent/TeslaAsideContent';
import { trackButtonAndLinkClick } from '../../../framework/store/FPTI/FPTIActions';
import { FLOW_TYPE, CREDIT_TYPE } from '../../../framework/App/AppConstants';
import './AsideContentContainer.less';

export class AsideContentContainer extends Component {

    static propTypes = {
        creditType: PropTypes.string,
        financingDetails: PropTypes.object,
        incentivesDetails: PropTypes.object,
        isCore: PropTypes.bool,
        isReuse: PropTypes.bool,
        isTeslaFlow: PropTypes.bool.isRequired,
        mppInstallmentsTermsUrl: PropTypes.string,
        defaultMessage: PropTypes.string,
        flow: PropTypes.string,
        asideContainerStyle: PropTypes.string,
        showCYCO: PropTypes.bool
    };

    getAsideImage(creditType, isTeslaFlow, showCYCO, isCore, isAcq) {
        const calendarIcon = <div className="calendar-img" />;
        const walletIcon = <div className="wallet-img" />;
        const stopwatchIcon = <div className="stopwatch-img" />;

        if (isTeslaFlow) {
            return calendarIcon;
        }

        switch (creditType) {
            case CREDIT_TYPE.INSTALLMENTS:
            case CREDIT_TYPE.NO_INTEREST:
                return walletIcon;
            default:
                if (showCYCO && isCore && isAcq) {
                    return stopwatchIcon;
                }
                return calendarIcon;
        }
    }

    getAsideContent() {
        const {creditType, incentivesDetails, financingDetails, isTeslaFlow, mppInstallmentsTermsUrl, defaultMessage, showCYCO, isCore, isReuse} = this.props;
        const isAcq = !isReuse;
        const imgElement = this.getAsideImage(creditType, isTeslaFlow, showCYCO, isCore, isAcq);

        if (isTeslaFlow) {
            return <TeslaAsideContent imgElt={imgElement} />;
        } else if (!_.isEmpty(incentivesDetails, true)) {
            return <IncentivesAsideContent incentivesDetails={incentivesDetails} imgElt={imgElement} />;
        } else {
            return (
                <DefaultAsideContent
                    creditType={creditType}
                    financingDetails={financingDetails}
                    imgElt={imgElement}
                    mppInstallmentsTermsUrl={mppInstallmentsTermsUrl}
                    defaultMessage={defaultMessage}
                />
            );
        }
    }

    render() {
        const { asideContainerStyle } = this.props;

        return (
            <div className={`AsideContentContainer ${asideContainerStyle ? asideContainerStyle : ''}`}>
                {this.getAsideContent()}
            </div>
        );
    }
}
export const mapStateToProps = (state, ownProps) => ({
    creditType: _.get(ownProps, 'creditType') || _.get(state, 'cycoPage.cycoSelectedOption.credit_type') || _.get(state, 'serverData.financingDetails.credit_type', CREDIT_TYPE.CORE),
    financingDetails: _.get(state, 'serverData.financingDetails') || {},
    incentivesDetails: _.get(state, 'serverData.incentivesDetails') || {},
    isReuse: _.get(state, 'serverData.isReuse', false),
    isTeslaFlow: _.get(state, 'serverData.flow') === FLOW_TYPE.TESLA,
    mppInstallmentsTermsUrl: _.get(state, 'serverData.mppInstallmentsTermsUrl', ''),
    flow: _.get(state, 'serverData.flow'),
    showCYCO: _.get(state, 'serverData.showCYCO', false)
});

export const mapDispatchToProps = dispatch => ({
    trackButtonAndLinkClick
});

export default connect(mapStateToProps, mapDispatchToProps)(AsideContentContainer);
